// semeia-disable-reexport
import ConsultationReportWrittenQuestion from "parog-web/models/consultation/consultation-report-written-question";

export interface Question {
  issue: string;
  answer?: string;
}

export function getIntialInterviewQuestionsOncoPharma(): ConsultationReportWrittenQuestion[] {
  return [
    new ConsultationReportWrittenQuestion(
      "personal-context",
      "Contexte personnel et socio-environnemental (fragilité du patient, entourage, conditions de vie...)"
    ),
    new ConsultationReportWrittenQuestion(
      "life-habit",
      "Habitudes de vie (alimentation, alcool, tabac, activité physique, ...)"
    ),
    new ConsultationReportWrittenQuestion(
      "treatment-perception",
      "Perception et connaissance du traitement par le patient et des règles de prise du médicament"
    ),
    new ConsultationReportWrittenQuestion(
      "oral-treatment-medic-knowledge",
      "Niveau d'information du médecin traitant sur le traitement anticancéreux oral"
    ),
    new ConsultationReportWrittenQuestion(
      "observance-patient-knowledge",
      "Connaissances par le patient de l'importance de l'observance"
    ),
    new ConsultationReportWrittenQuestion(
      "forget-patient-knowledge",
      "Connaissances par le patient de la conduite à tenir en cas d’oubli"
    ),
    new ConsultationReportWrittenQuestion(
      "treatment-patient-questions",
      "Questions du patient relatives à son traitement, sa prise en charge ou sa maladie"
    ),
    new ConsultationReportWrittenQuestion(
      "interview-synthesis",
      "Synthèse de l'entretien et appréciation du niveau d’information du patient"
    ),
    new ConsultationReportWrittenQuestion(
      "contact-with-medical-team",
      "Prise de contact avec l'équipe médicale ou orientation du patient à prévoir"
    ),
    new ConsultationReportWrittenQuestion("comment", "Commentaire")
  ];
}

export function getSecondInterviewQuestionsOncoPharma(): ConsultationReportWrittenQuestion[] {
  return [
    new ConsultationReportWrittenQuestion(
      "personal-context-changes",
      "Eléments personnels de contexte de vie,  ou habitudes de vie du patient ayant changés depuis le dernier entretien"
    ),
    new ConsultationReportWrittenQuestion(
      "general-feeling-patient",
      "Ressenti général du patient concernant son traitement"
    ),
    new ConsultationReportWrittenQuestion(
      "adverse-events-patient-knowledge",
      "Connaissances par le patient des règles générales de prise de son traitement et de la conduite à tenir en cas d'effets indésirables"
    ),
    new ConsultationReportWrittenQuestion(
      "adverse-events",
      "Effets indésirables ressentis par le patient et liés à son traitement"
    ),
    new ConsultationReportWrittenQuestion(
      "external-help-needed",
      "Besoin du patient d'avoir une aide extérieure (psychologique, aide au quotidien...) ?"
    ),
    new ConsultationReportWrittenQuestion(
      "treatment-patient-questions",
      "Questions du patient relatives à son traitement, sa prise en charge ou sa maladie"
    ),
    new ConsultationReportWrittenQuestion(
      "quick-synthesis-related-to-patient-knowledge",
      "Rapide synthèse de l'entretien et appréciation du pharmacien sur le niveau d’information du patient"
    ),
    new ConsultationReportWrittenQuestion(
      "contact-with-prescriptor",
      "Prise de contact vers le prescripteur ou orientation du patient (renseigner si concerné)"
    ),
    new ConsultationReportWrittenQuestion("comment", "Commentaire")
  ];
}

export function getThirdInterviewQuestionsOncoPharma(): ConsultationReportWrittenQuestion[] {
  return [
    new ConsultationReportWrittenQuestion(
      "personal-context-changes",
      "Eléments personnels de contexte de vie,  ou habitudes de vie du patient ayant changés depuis le dernier entretien"
    ),
    new ConsultationReportWrittenQuestion(
      "observance-consciousness",
      "Conscience du patient de l'importance d’être observant et connaissances des risques en cas d'oubli"
    ),
    new ConsultationReportWrittenQuestion(
      "forget-patient-procedure-knowledge",
      "Connaissances par le patient de la procédure à suivre en cas d'oubli de prise du traitement"
    ),
    new ConsultationReportWrittenQuestion(
      "number-forget-patient",
      "Nombre d'oubli de prise du traitement par le patient. Et réac Le patient a-t-il déjà oublié de prendre son traitement ? Si oui, comment a-t-il réagi ?"
    ),
    new ConsultationReportWrittenQuestion(
      "treatment-patient-questions",
      "Questions du patient relatives à son traitement, sa prise en charge ou sa maladie"
    ),
    new ConsultationReportWrittenQuestion(
      "quick-synthesis-related-to-patient-knowledge",
      "Rapide synthèse de l'entretien et appréciation du pharmacien sur le niveau d’information du patient"
    ),
    new ConsultationReportWrittenQuestion(
      "contact-with-prescriptor",
      "Prise de contact vers le prescripteur ou orientation du patient (renseigner si concerné)"
    ),
    new ConsultationReportWrittenQuestion("comment", "Commentaire")
  ];
}

export function getInclusionQuestions(): ConsultationReportWrittenQuestion[] {
  return [
    new ConsultationReportWrittenQuestion(
      "comment-inclusion",
      "Commentaire",
      `CONSENTEMENT DU PATIENT : oral / écrit
    \nINCLUSION : par téléphone / en présentiel / avec un tiers :
    \nFORMATION A L'OUTIL : oui / partielle / non
    \nPROFIL UTILISATEUR : non / moyennement / connecté
    \nMATERIEL DU PATIENT : tensiomètre, balance, spiromètre
    \nAPPLICATION GEREE PAR :
    \nMETHODE RECUEIL MESURES CLINIQUES : autonome / relevé de mesures / dispositif connecté
    \nMEDECIN DE RATTACHEMENT :
    \nAUTRE:`
    )
  ];
}

export function getDefaultQuestions(): ConsultationReportWrittenQuestion[] {
  return [new ConsultationReportWrittenQuestion("comment", "Commentaire")];
}
